function Loader({ enabled, children }) {
  return (
    <div className="loader" style={{ display: enabled ? "flex" : undefined, flexDirection: "column" }}>
      <span className="icon-wrapper">
        <i className="fa-solid fa-circle-notch fa-spin"></i>
      </span>
      {children}
    </div>
  )
}

export default Loader
